module.exports = __webpack_public_path__ + "img/howto_sp01.aaa99295.png";